import { Alert } from '@mui/material'
import React from 'react'

import { SignedOutForm } from 'components/authentication/SignedOutForm'
import SignedOutFormContainer from 'components/authentication/SignedOutFormContainer'
import { UpperBackText } from 'components/authentication/UpperBackText'
import Button from 'components/common/Button'
import InputTextField from 'components/common/InputTextField'

export const MFAForm: React.FC<{
  token: string
  submitting: boolean
  handleBack: () => void
  handleTokenChange: (token: string) => void
  handleTokenSubmission: () => void
  signInError?: string
}> = ({
  token,
  submitting,
  handleBack,
  handleTokenChange,
  handleTokenSubmission,
  signInError
}) => {
  return (
    <SignedOutFormContainer>
      <UpperBackText onClick={handleBack}>Back to login</UpperBackText>
      <SignedOutForm
        title="Enter your MFA token"
        onSubmit={(event) => {
          event.preventDefault()
          handleTokenSubmission()
        }}
      >
        <InputTextField
          data-test-mfa-token-input
          disabled={submitting}
          label="MFA Token"
          name="token"
          value={token}
          onChange={(event) => handleTokenChange(event.target.value)}
        />
        {signInError && (
          <Alert
            data-testid="sign-in-credentials-error"
            id="signin-error"
            severity="error"
            sx={{ marginBottom: 3 }}
          >
            {signInError}
          </Alert>
        )}
        <Button
          data-test-mfa-continue-button
          primary
          stretch
          disabled={submitting}
          type="submit"
        >
          Continue
        </Button>
      </SignedOutForm>
    </SignedOutFormContainer>
  )
}
